$(function () {

  // ============================================================
  // sticky header
  // ============================================================
  var cloneHeader = $('.p-header').clone(true).addClass('is-clone').appendTo('body');
  var openOffsetHeader = $('.p-header').height();
  $(window).on('load scroll', function () {
    var now = $(window).scrollTop();
    if (now > openOffsetHeader) {
      cloneHeader.addClass('is-show');
    } else {
      cloneHeader.removeClass('is-show');
    }
  });


  // ============================================================
  // ハンバーガー / ドロワー
  // ============================================================
  function resetDrawerPanel() {
    $('.p-drawer__panel[data-drawer-panel="shop"]').attr('hidden', true);
    $('.p-drawer__panel[data-drawer-panel="main"]').removeAttr('hidden');
  }

  $(document).on('click', '.p-header__hamburger, .p-drawer__header__close', function () {
    $('html').toggleClass('is-open');
    $('.p-drawer').toggleClass('is-show');
    if (!$('html').hasClass('is-open')) {
      resetDrawerPanel();
    }
  });

  $(document).on('click', '.p-drawer a:not([data-drawer-open])', function () {
    $('html').removeClass('is-open');
    $('.p-drawer').removeClass('is-show');
  });

  // カートドロワーと同じく、背景の暗い部分をクリックしたら閉じる
  $(document).on('click', '.p-drawer', function (e) {
    if (e.target === this) {
      $('html').removeClass('is-open');
      $(this).removeClass('is-show');
      resetDrawerPanel();
    }
  });

  $(document).on('click', '[data-drawer-open]', function (e) {
    e.preventDefault();
    $('.p-drawer__panel[data-drawer-panel="main"]').attr('hidden', true);
    $('.p-drawer__panel[data-drawer-panel="' + $(this).data('drawer-open') + '"]').removeAttr('hidden');
  });

  $(document).on('click', '[data-drawer-back]', function () {
    resetDrawerPanel();
  });


  // ============================================================
  // inview (スクロールでふわっと表示)
  // ============================================================
  if ('IntersectionObserver' in window) {
    var inviewObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inviewed');
          inviewObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    });

    document.querySelectorAll('.u-inview').forEach(function (el) {
      inviewObserver.observe(el);
    });
  } else {
    $('.u-inview').addClass('is-inviewed');
  }


  // ============================================================
  // 商品画像サムネイル切り替え（p-shopProduct__gallery__thumbsは
  // Swiperのサムネイルクリック処理側で制御。ここでは静止画のみのフォールバック）
  // ============================================================
  $(document).on('click', '.p-shopProduct__gallery__thumbs__item', function () {
    var $this = $(this);
    $('.p-shopProduct__gallery__thumbs__item').removeClass('is-active');
    $this.addClass('is-active');
  });


  // ============================================================
  // メインビジュアル スライダー
  // ============================================================
  if ($('.p-top__mainVisual__swiper').length) {
    new Swiper('.p-top__mainVisual__swiper .swiper-container', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.p-top__mainVisual__swiper .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  }


  // ============================================================
  // News スライダー
  // ============================================================
  if ($('.p-top__news__swiper').length) {
    new Swiper('.p-top__news__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      observer: true,
      observeParents: true,
    });
  }


  // ============================================================
  // Blog スライダー
  // ============================================================
  if ($('.p-top__blog__swiper').length) {
    new Swiper('.p-top__blog__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      observer: true,
      observeParents: true,
    });
  }


  // ============================================================
  // Single Blog Recommends スライダー
  // ============================================================
  if ($('.p-singleBlog__recommends__swiper').length) {
    new Swiper('.p-singleBlog__recommends__swiper', {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 20,
          slidesOffsetBefore: window.innerWidth * 16 / 375,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
        },
      },
    });
  }


  // ============================================================
  // What is Kokeshi - 12 Traditional Styles スライダー (SPのみ)
  // ============================================================
  if ($('.p-whatIsKokeshi__styles__swiper').length && window.matchMedia('(max-width: 767px)').matches) {
    new Swiper('.p-whatIsKokeshi__styles__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesOffsetBefore: window.innerWidth * 16 / 375,
      pagination: {
        el: '.p-whatIsKokeshi__styles__pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + String(index + 1).padStart(2, '0') + '</span>';
        }
      },
    });
  }


  // ============================================================
  // Shop Index フィルター（カテゴリ/系統/工人名などのドリルダウン）
  // ============================================================
  function resetFilterPanel($filter) {
    $filter.find('[data-filter-panel]').attr('hidden', true);
    $filter.find('[data-filter-panel="root"]').removeAttr('hidden');
  }

  $(document).on('click', '.p-shopIndex__toolbar__filter__button', function (e) {
    e.stopPropagation();
    var $filter = $(this).closest('.p-shopIndex__toolbar__filter');
    var isOpen = $filter.hasClass('is-open');
    $('.p-shopIndex__toolbar__filter').removeClass('is-open');
    $('.p-shopIndex__toolbar__filter__button').attr('aria-expanded', 'false');
    if (!isOpen) {
      $filter.addClass('is-open');
      $(this).attr('aria-expanded', 'true');
      resetFilterPanel($filter);
    }
  });

  $(document).on('click', '[data-filter-close]', function (e) {
    e.stopPropagation();
    $('.p-shopIndex__toolbar__filter').removeClass('is-open');
    $('.p-shopIndex__toolbar__filter__button').attr('aria-expanded', 'false');
  });

  $(document).on('click', '[data-filter-open]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $filter = $(this).closest('.p-shopIndex__toolbar__filter');
    $filter.find('[data-filter-panel]').attr('hidden', true);
    $filter.find('[data-filter-panel="' + $(this).data('filter-open') + '"]').removeAttr('hidden');
  });

  $(document).on('click', '[data-filter-back]', function (e) {
    e.stopPropagation();
    var $filter = $(this).closest('.p-shopIndex__toolbar__filter');
    $filter.find('[data-filter-panel]').attr('hidden', true);
    $filter.find('[data-filter-panel="' + $(this).data('filter-back') + '"]').removeAttr('hidden');
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.p-shopIndex__toolbar__filter').length) {
      $('.p-shopIndex__toolbar__filter').removeClass('is-open');
      $('.p-shopIndex__toolbar__filter__button').attr('aria-expanded', 'false');
    }
  });

  // ============================================================
  // Sort by ドロップダウン（ショップ一覧・検索結果 共通）
  // ============================================================
  $(document).on('click', '.p-shopIndex__toolbar__sort__button, .p-searchResults__toolbar__sort__button', function (e) {
    e.stopPropagation();
    var $sort = $(this).closest('.p-shopIndex__toolbar__sort, .p-searchResults__toolbar__sort');
    var isOpen = $sort.hasClass('is-open');
    $('.p-shopIndex__toolbar__sort, .p-searchResults__toolbar__sort').removeClass('is-open');
    $('.p-shopIndex__toolbar__sort__button, .p-searchResults__toolbar__sort__button').attr('aria-expanded', 'false');
    if (!isOpen) {
      $sort.addClass('is-open');
      $(this).attr('aria-expanded', 'true');
    }
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.p-shopIndex__toolbar__sort, .p-searchResults__toolbar__sort').length) {
      $('.p-shopIndex__toolbar__sort, .p-searchResults__toolbar__sort').removeClass('is-open');
      $('.p-shopIndex__toolbar__sort__button, .p-searchResults__toolbar__sort__button').attr('aria-expanded', 'false');
    }
  });


  // ============================================================
  // スムーススクロール
  // ============================================================
  $(document).on('click', 'a[href^="#"].u-anchor', function () {
    var speed = 500;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;
    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  // ============================================================
  // 検索バー
  // ============================================================
  $(document).on('click', '.p-header__search', function (e) {
    e.preventDefault();
    $('.p-searchBar').addClass('is-show');
    setTimeout(function () {
      $('.p-searchBar__form__input').focus();
    }, 400);
  });

  $(document).on('click', '.p-searchBar__close', function () {
    $('.p-searchBar').removeClass('is-show');
  });

  $(document).on('click', '.p-searchBar', function (e) {
    if (!$(e.target).closest('.p-searchBar__inner').length) {
      $(this).removeClass('is-show');
    }
  });

  // ============================================================
  // Search Results × ボタンで input クリア
  // ============================================================
  $(document).on('click', '.p-searchResults__head__form__close', function () {
    $('.p-searchResults__head__form__input').val('').focus();
  });


  // ============================================================
  // 商品詳細ギャラリー
  // ============================================================
  if ($('.p-shopProduct__gallery__swiper').length) {
    var productSwiper = new Swiper('.p-shopProduct__gallery__swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.p-shopProduct__gallery__pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
        },
      },
    });

    $(document).on('click', '.p-shopProduct__gallery__thumbs__item', function () {
      var index = $(this).data('index');
      productSwiper.slideTo(index);
    });

    productSwiper.on('slideChange', function () {
      var index = productSwiper.activeIndex;
      $('.p-shopProduct__gallery__thumbs__item').removeClass('is-active');
      $('.p-shopProduct__gallery__thumbs__item[data-index="' + index + '"]').addClass('is-active');
    });
  }


  // ============================================================
  // Related スライダー (Category/Other 5列表示)
  // ============================================================
  if ($('.p-shopProduct__related__swiper').length) {
    $('.p-shopProduct__related__swiper').each(function () {
      new Swiper(this, {
        slidesPerView: 5,
        spaceBetween: 20,
        loop: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        },
      });
    });
  }


  // ============================================================
  // Shopify AJAX カート
  // ============================================================
  var money_format = window.themeMoneyFormat || '¥{{amount_no_decimals}}';

  function formatMoney(cents) {
    var value = cents / 100;
    var withComma = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimalsComma = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return money_format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
      .replace(/\{\{\s*amount\s*\}\}/, withDecimalsComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withDecimalsComma);
  }

  function cartItemHtml(item, line) {
    return '' +
      '<li class="p-cartDrawer__list__item" data-cart-drawer-item data-line="' + line + '">' +
      '  <div class="p-cartDrawer__list__item__image"><img src="' + (item.image || window.themeNoImageUrl || '') + '" alt=""></div>' +
      '  <div class="p-cartDrawer__list__item__info">' +
      '    <p class="p-cartDrawer__list__item__info__name">' + item.product_title + '</p>' +
      '    <p class="p-cartDrawer__list__item__info__price">' + formatMoney(item.final_line_price) + '</p>' +
      '  </div>' +
      '  <button type="button" class="p-cartDrawer__list__item__remove" aria-label="Remove" data-cart-drawer-remove data-line="' + line + '"></button>' +
      '</li>';
  }

  function cartRowHtml(item, line) {
    return '' +
      '<li class="p-cart__table__item" data-cart-item data-line="' + line + '">' +
      '  <div class="p-cart__table__item__product">' +
      '    <div class="p-cart__table__item__image"><img src="' + (item.image || window.themeNoImageUrl || '') + '" alt=""></div>' +
      '    <div class="p-cart__table__item__info">' +
      '      <p class="p-cart__table__item__info__name">' + item.product_title + '</p>' +
      '      <p class="p-cart__table__item__info__price">' + formatMoney(item.final_price) + '</p>' +
      '    </div>' +
      '  </div>' +
      '  <div class="p-cart__table__item__quantity">' +
      '    <div class="p-cart__table__item__quantity__control">' +
      '      <button type="button" class="p-cart__table__item__quantity__minus" data-cart-qty-minus data-line="' + line + '">&minus;</button>' +
      '      <input type="number" class="p-cart__table__item__quantity__input" value="' + item.quantity + '" min="1" data-cart-qty-input data-line="' + line + '">' +
      '      <button type="button" class="p-cart__table__item__quantity__plus" data-cart-qty-plus data-line="' + line + '">+</button>' +
      '    </div>' +
      '    <button type="button" class="p-cart__table__item__remove" data-cart-remove data-line="' + line + '"></button>' +
      '  </div>' +
      '  <div class="p-cart__table__item__total" data-cart-item-total>' + formatMoney(item.final_line_price) + '</div>' +
      '</li>';
  }

  function renderCart(cart) {
    var $count = $('.p-header__cart__count');
    $count.text(cart.item_count);
    $count.toggleClass('is-show', cart.item_count > 0);

    var $drawer = $('.p-cartDrawer');
    $drawer.toggleClass('is-empty', cart.item_count === 0);
    var $drawerList = $('[data-cart-drawer-list]');
    if ($drawerList.length) {
      $drawerList.empty();
      cart.items.forEach(function (item, i) {
        $drawerList.append(cartItemHtml(item, i + 1));
      });
    }

    var $cartList = $('[data-cart-list]');
    if ($cartList.length) {
      if (cart.item_count === 0) {
        $cartList.html('<li class="p-cart__table__empty">Your cart is empty.</li>');
      } else {
        $cartList.empty();
        cart.items.forEach(function (item, i) {
          $cartList.append(cartRowHtml(item, i + 1));
        });
      }
      $('[data-cart-total]').text(formatMoney(cart.total_price));
      $('.p-cart__foot__checkout').prop('disabled', cart.item_count === 0);
    }
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); }).then(renderCart);
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  // ヘッダーのカートアイコン → ドロワー開閉
  $(document).on('click', '.p-header__cart', function (e) {
    e.preventDefault();
    $('.p-cartDrawer').addClass('is-show');
  });

  $(document).on('click', '.p-cartDrawer__head__close', function () {
    $('.p-cartDrawer').removeClass('is-show');
  });

  $(document).on('click', '.p-cartDrawer', function (e) {
    if (e.target === this) {
      $(this).removeClass('is-show');
    }
  });

  $(document).on('click', '.p-cartDrawer__empty__button', function () {
    $('.p-cartDrawer').removeClass('is-show');
  });

  // カートドロワー内の削除
  $(document).on('click', '[data-cart-drawer-remove]', function () {
    changeCartLine($(this).data('line'), 0);
  });

  // カートページ 数量 ± / 直接入力 / 削除
  $(document).on('click', '[data-cart-qty-minus]', function () {
    var $input = $(this).siblings('[data-cart-qty-input]');
    var value = Math.max(1, parseInt($input.val(), 10) - 1);
    $input.val(value);
    changeCartLine($(this).data('line'), value);
  });

  $(document).on('click', '[data-cart-qty-plus]', function () {
    var $input = $(this).siblings('[data-cart-qty-input]');
    var value = parseInt($input.val(), 10) + 1;
    $input.val(value);
    changeCartLine($(this).data('line'), value);
  });

  $(document).on('change', '[data-cart-qty-input]', function () {
    var value = Math.max(1, parseInt($(this).val(), 10) || 1);
    changeCartLine($(this).data('line'), value);
  });

  $(document).on('click', '[data-cart-remove]', function () {
    changeCartLine($(this).data('line'), 0);
  });

  // 商品詳細: Add to cart / Buy it now（どちらも /cart/add.js 経由。Buy it nowはその後 /checkout へ遷移）
  $(document).on('submit', '#product-form', function (e) {
    e.preventDefault();
    var $submitter = $(e.originalEvent && e.originalEvent.submitter);
    var isBuyNow = $submitter.is('[data-buy-now]');
    var $buttons = $(this).find('.p-shopProduct__info__addToCart__button, .p-shopProduct__info__buyNow__button');
    var $otherButton = $buttons.not($submitter);
    $submitter.addClass('is-loading');
    $otherButton.addClass('is-disabled');
    var formData = new FormData(this);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (isBuyNow) {
          window.location.href = '/checkout';
          return;
        }
        return refreshCart().then(function () { $('.p-cartDrawer').addClass('is-show'); });
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        if (!isBuyNow) {
          $buttons.removeClass('is-loading is-disabled');
        }
      });
  });


  // ============================================================
  // 最近見た商品 (localStorageで閲覧履歴を保持)
  // ============================================================
  var RECENTLY_VIEWED_KEY = 'recentlyViewedProducts';
  var RECENTLY_VIEWED_MAX = 10;

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function addRecentlyViewed(handle) {
    var list = getRecentlyViewed().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list.slice(0, RECENTLY_VIEWED_MAX)));
  }

  function resizeShopifyImage(url, size) {
    if (!url) return window.themeNoImageUrl || '';
    var i = url.lastIndexOf('.');
    if (i === -1) return url;
    return url.slice(0, i) + '_' + size + 'x' + url.slice(i);
  }

  function recentlyViewedCardHtml(product) {
    return '' +
      '<div class="swiper-slide">' +
      '  <a href="' + product.url + '" class="p-shopProduct__related__card">' +
      '    <div class="p-shopProduct__related__card__image"><img src="' + resizeShopifyImage(product.featured_image, 600) + '" alt="" loading="lazy"></div>' +
      '    <div class="p-shopProduct__related__card__info">' +
      '      <p class="p-shopProduct__related__card__info__name">' + product.title + '</p>' +
      '      <p class="p-shopProduct__related__card__info__price">' + formatMoney(product.price) + '（税込）</p>' +
      '    </div>' +
      '  </a>' +
      '</div>';
  }

  var $productSection = $('[data-product-handle]');
  if ($productSection.length) {
    addRecentlyViewed($productSection.data('product-handle'));
  }

  var $recentlyViewed = $('[data-recently-viewed]');
  if ($recentlyViewed.length) {
    var currentHandle = $productSection.data('product-handle');
    var handles = getRecentlyViewed().filter(function (h) { return h !== currentHandle; }).slice(0, 9);

    if (handles.length) {
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;

        var $list = $recentlyViewed.find('[data-recently-viewed-list]');
        products.forEach(function (product) {
          $list.append(recentlyViewedCardHtml(product));
        });
        $recentlyViewed.removeAttr('hidden');

        new Swiper($recentlyViewed.find('.swiper-container')[0], {
          slidesPerView: 5,
          spaceBetween: 20,
          loop: true,
          observer: true,
          observeParents: true,
          breakpoints: {
            0: { slidesPerView: 1.5, spaceBetween: 12 },
            768: { slidesPerView: 5, spaceBetween: 20 },
          },
        });
      });
    }
  }


  // ============================================================
  // FAQ アコーディオン (slideDown/slideUpで開閉)
  // ============================================================
  $(document).on('click', '.p-faq__item__question', function (e) {
    e.preventDefault();
    var $item = $(this).closest('.p-faq__item');
    var $answer = $item.children('.p-faq__item__answer');

    if ($item.prop('open')) {
      $answer.stop(true, true).slideUp(300, function () {
        $item.removeAttr('open');
        $answer.removeAttr('style');
      });
    } else {
      $answer.stop(true, true).hide();
      $item.attr('open', true);
      $answer.slideDown(300);
    }
  });

  // 回答部分クリックでも閉じる（リンクのクリックは遷移を優先し閉じない）
  $(document).on('click', '.p-faq__item__answer', function (e) {
    if ($(e.target).is('a') || $(e.target).closest('a').length) {
      return;
    }
    var $item = $(this).closest('.p-faq__item');
    var $answer = $(this);
    $answer.stop(true, true).slideUp(300, function () {
      $item.removeAttr('open');
      $answer.removeAttr('style');
    });
  });

  // ============================================================
  // Parsleyバリデーション初期化
  // data-parsley-validate はフォーム内側のdivに付いており、実際の
  // <form>に対してParsleyが初期化されていないと送信イベントを
  // 検知できないため、data-parsley-validateの祖先formに対して
  // 明示的にParsleyを初期化する。
  // ============================================================
  $('[data-parsley-validate]').each(function () {
    var $form = $(this).closest('form');
    if ($form.length && window.Parsley) {
      $form.parsley();
    }
  });

  // ============================================================
  // お問い合わせフォーム：チェックボックスを1つのフィールドに集約
  // Shopifyのcontactフォームは contact[Topic][] のような配列値を
  // 受け付けず「無効です」エラーになるため、チェックボックス自体は
  // name を持たせず（＝送信しない）、選択値をカンマ区切りにして
  // hidden の contact[Topic] / contact[Location] に入れて送る。
  // ============================================================
  $('.p-contactForm__form').each(function () {
    var $wrap = $(this);
    var $form = $wrap.closest('form');
    if (!$form.length) {
      return;
    }

    var syncGroups = function () {
      $wrap.find('input[type="hidden"][data-contact-group]').each(function () {
        var group = $(this).attr('data-contact-group');
        var values = $wrap
          .find('input[type="checkbox"][data-contact-name="' + group + '"]:checked')
          .map(function () {
            return this.value;
          })
          .get();
        $(this).val(values.join(', '));
      });
    };

    $wrap.on('change', 'input[type="checkbox"][data-contact-name]', syncGroups);
    $form.on('submit', syncGroups);
    syncGroups();
  });

});
